import { render, staticRenderFns } from "./MedicalDisposalList.vue?vue&type=template&id=642279d2&scoped=true&"
import script from "./MedicalDisposalList.vue?vue&type=script&lang=js&"
export * from "./MedicalDisposalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642279d2",
  null
  
)

export default component.exports